export const loadWebManifest = () => {
  if (typeof document === 'undefined') return;

  if (document.querySelector('link[rel="manifest"]')) return;
  const load = () => {
    const manifestPath = `${__PUBLIC_PATH__}site.webmanifest`;
    const link = document.createElement('link');
    link.rel = 'manifest';
    link.href = manifestPath;
    document.head.appendChild(link);
  };

  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(load, { timeout: 3000 });
  } else {
    setTimeout(load, 0);
  }
};
